export default __webpack_public_path__ + "i18n/zh-TW.ca8f563083632f1b859db0ef705d3e32.json";